import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "form", "printLink", "submitLink", "controls", "columnTotal", "rowTotal", "overallTotal"]

  connect() {
    if (!document.querySelector('[data-namespace*="projects/"]')) return

    // Show buttons
    document.querySelectorAll('.show-after-load').forEach(el => {
      el.style.opacity = 1
    })

    window.changed = false

    this.bindTextareaListeners()
    this.bindNavWarning()
    this.bindChangeTracking()
    this.bindPrintCheck()
    this.bindSubmission()
    this.bindTotalsUpdate()
    this.setupAceEditor()
  }

  bindTextareaListeners() {
    document.querySelectorAll('textarea.explanation[maxlength]').forEach(textarea => {
      textarea.addEventListener('keyup', function () {
        const label = this.closest('div').querySelector('label')
        if (label) {
          label.textContent = `Erläuterung / Bewertung (${this.value.length} von ${this.maxLength} Zeichen)`
        }
      })
    })
  }

  bindNavWarning() {
    document.querySelectorAll('nav a').forEach(link => {
      link.addEventListener('click', function (e) {
        if (link.dataset.form) return

        if (window.changed && link.closest('#print') === null) {
          if (!confirm('Sie haben ungespeicherte Änderungen. Wollen Sie die Maske tatsächlich verlassen?')) {
            e.preventDefault()
          }
        }
      })
    })
  }

  bindChangeTracking() {
    document.addEventListener('change', event => {
      if (event.target.matches('input, textarea')) {
        window.changed = true
        document.querySelectorAll('a[data-form]').forEach(link => {
          link.innerHTML = '<i class="bi bi-save"></i> Änderungen speichern'
          link.classList.remove('text-success')
          link.classList.add('text-warning')
        })
      }
    })
  }

  bindPrintCheck() {
    const printLink = document.querySelector('#print a')
    if (printLink) {
      printLink.addEventListener('click', function (e) {
        if (window.changed) {
          alert('Bitte speichern Sie Ihre Änderungen, bevor Sie die Druckansicht öffnen.')
          e.preventDefault()
        }
      })
    }
  }

  bindSubmission() {
    document.addEventListener('mouseup', event => {
      const link = event.target.closest('a[data-form]')
      if (!link) return

      const controls = link.closest('.controls')
      if (controls) {
        controls.querySelectorAll('input').forEach(input => {
          input.disabled = true
        })
      }

      link.innerHTML = '<i class="bi bi-save"></i> Bitte warten...'
      link.classList.add('text-warning')

      const targetForm = document.querySelector(`#${link.dataset.form} input[type=submit]`)
      if (targetForm) targetForm.click()

      event.preventDefault()
    })
  }

  bindTotalsUpdate() {
    document.addEventListener('change', event => {
      const input = event.target
      if (!input.matches('input')) return

      const td = input.closest('td')
      if (!td) return
      const table = input.closest('table')
      const column = td.dataset.column
      const row = td.dataset.row
      const group = td.dataset.group

      const columnTotal = table.querySelector(`[data-column="${column}"][data-group="${group}"] .column-total`)
      const rowTotal = table.querySelector(`[data-row="${row}"][data-group="${group}"] .row-total`)
      const overallTotalEl = table.querySelector('.overall-total')

      if (columnTotal) {
        let sum = 0
        table.querySelectorAll('td.int-answer input.level-1, td.float-answer input.level-1').forEach(el => {
          const parentTd = el.closest('td')
          if (parentTd.dataset.column === column && parentTd.dataset.group === group) {
            sum += +el.value || 0
          }
        })
        columnTotal.value = sum
      }

      if (rowTotal) {
        let sum = 0
        td.closest('tr').querySelectorAll('td.int-answer input, td.float-answer input').forEach(el => {
          if (!el.disabled) {
            sum += +el.value || 0
          }
        })
        rowTotal.value = sum
      }

      if (overallTotalEl) {
        let overall = 0
        table.querySelectorAll(`[data-group="${group}"] .column-total`).forEach(el => {
          overall += +el.value || 0
        })
        overallTotalEl.value = overall
      }
    })
  }

  setupAceEditor() {
    const editorEl = document.getElementById('editor')
    if (!editorEl) return

    window.editor = ace.edit('editor')
    editor.getSession().setMode('ace/mode/text')
    editor.getSession().setUseWrapMode(true)
    editor.getSession().setUseSoftTabs(false)

    const form = document.getElementById('project_form')
    if (form) {
      form.addEventListener('submit', function () {
        const textarea = form.querySelector('textarea#project_template')
        if (textarea) {
          textarea.value = editor.getSession().getValue()
        }
      })
    }
  }
}
